var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.482422,
    y: 0.508301,
    width: 33.518,
    height: 33.518,
    rx: 16.759,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7018 10.7276C10.8424 10.5872 11.033 10.5083 11.2318 10.5083C11.4305 10.5083 11.6211 10.5872 11.7618 10.7276L23.7618 22.7276C23.8354 22.7963 23.8946 22.8791 23.9355 22.9711C23.9765 23.0631 23.9986 23.1624 24.0004 23.2631C24.0021 23.3638 23.9836 23.4638 23.9459 23.5572C23.9082 23.6506 23.852 23.7355 23.7808 23.8067C23.7096 23.8779 23.6247 23.934 23.5314 23.9718C23.438 24.0095 23.3379 24.028 23.2372 24.0262C23.1365 24.0245 23.0372 24.0024 22.9452 23.9614C22.8532 23.9204 22.7704 23.8613 22.7018 23.7876L10.7018 11.7876C10.5613 11.647 10.4824 11.4564 10.4824 11.2576C10.4824 11.0589 10.5613 10.8683 10.7018 10.7276Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7613 10.7276C23.9017 10.8683 23.9806 11.0589 23.9806 11.2576C23.9806 11.4564 23.9017 11.647 23.7613 11.7876L11.7613 23.7876C11.6191 23.9201 11.4311 23.9922 11.2368 23.9888C11.0425 23.9854 10.8571 23.9067 10.7197 23.7693C10.5823 23.6318 10.5035 23.4465 10.5001 23.2522C10.4967 23.0579 10.5688 22.8698 10.7013 22.7276L22.7013 10.7276C22.8419 10.5872 23.0325 10.5083 23.2313 10.5083C23.43 10.5083 23.6207 10.5872 23.7613 10.7276Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.dbc190c614bcd77bf2334054f67aa100.svg";
export { ForwardRef as ReactComponent };